export const TITLES = [
  { id: "title_0", text: "One request.", pos: "upper", size: 96 },
  { id: "title_1", text: "Every service, planned.", pos: "upper", size: 96 },
  { id: "title_2", text: "Confirmed.", pos: "lower-left", size: 84 },
];

export default function Title({ id }) {
  const t = TITLES.find((x) => x.id === id);
  if (!t) return null;
  const upper = t.pos === "upper";
  return (
    <div data-testid={`title-${id}`} className="serif" style={{ position: "relative", width: 1080, height: 1920, background: "transparent" }}>
      <div style={{ position: "absolute", left: upper ? 0 : 96, right: upper ? 0 : 96, top: upper ? 430 : 1380, textAlign: upper ? "center" : "left", fontSize: t.size, fontWeight: 600, letterSpacing: "0.02em", color: "#FBF8F7", lineHeight: 1.1, textShadow: "0 2px 6px rgba(0,0,0,.35), 0 8px 40px rgba(0,0,0,.35)" }}>
        {t.text}
      </div>
    </div>
  );
}
